import PropTypes from 'prop-types';

import {
  trans,
  useSoyuzBrandConfig,
  useSoyuzFlag
} from '@spotahome/soyuz/client';

import AlertBox from '../AlertBox';
import NewReleaseIcon from '../icons/NewReleaseIcon';

const BrandDiscountMessage = ({
  className = '',
  transKey = 'listing.book-now-card.brand-discount'
}) => {
  const { promoCode, name, discountPercentage } = useSoyuzBrandConfig();
  const isEnabled = useSoyuzFlag('ShowBrandDiscountMessage').isOn();

  return !!promoCode && isEnabled ? (
    <div className={className}>
      <AlertBox
        icon={<NewReleaseIcon />}
        iconPosition="top"
        roundedCorners
        message={
          <span
            dangerouslySetInnerHTML={{
              __html: trans(transKey, {
                brandName: name,
                discountPercentage
              })
            }}
          />
        }
      />
    </div>
  ) : null;
};

BrandDiscountMessage.propTypes = {
  className: PropTypes.string,
  transKey: PropTypes.string
};

export default BrandDiscountMessage;
